export default class Logger {
    constructor( core ) {
        this.core = core
    }

    ToConsole( type, namespace, ...args ) {
        if( type == 'error' )
        {
            console.error( namespace, ...args )
        } else {
            console.log( namespace, ...args )
        }
    }
}